import { Link } from 'react-router-dom';
import { toDisplayError } from '../../lib/errors';
import { Alert } from '../../components/ui/Alert';
import { Badge } from '../../components/ui/Badge';
import { Card, CardContent } from '../../components/ui/Card';
import { Spinner } from '../../components/ui/Spinner';
import { usePortalDossiers } from './hooks';

/**
 * LOT B3 — « Mes dossiers » : la liste des dossiers accessibles au client (périmètre imposé par le
 * serveur). Le filtrage n'est jamais fait ici ; on affiche ce que l'API autorise.
 */
export function PortalDossiersPage(): JSX.Element {
  const query = usePortalDossiers();

  return (
    <section className="mx-auto max-w-3xl space-y-4">
      <header>
        <h1 className="text-xl font-semibold text-slate-800">Mes dossiers</h1>
        <p className="text-sm text-slate-500">
          Consultez vos dossiers et téléchargez les documents validés qui vous sont destinés.
        </p>
      </header>

      {query.isPending ? (
        <Spinner label="Chargement de vos dossiers…" />
      ) : query.isError ? (
        <Alert variant="error" title="Dossiers indisponibles">
          {toDisplayError(query.error).message}
        </Alert>
      ) : query.data.length === 0 ? (
        <Card>
          <CardContent className="py-10 text-center text-sm text-slate-500">
            Aucun dossier ne vous est accessible pour le moment.
          </CardContent>
        </Card>
      ) : (
        <ul className="space-y-2">
          {query.data.map((d) => (
            <li key={d.id}>
              <Link
                to={`/portail/dossiers/${d.id}`}
                className="block rounded-lg border border-slate-200 bg-white p-4 hover:border-brand-300 hover:bg-brand-50/40"
              >
                <div className="flex items-center justify-between gap-3">
                  <span className="font-medium text-slate-800">{d.numero}</span>
                  <Badge tone="info">{d.statut}</Badge>
                </div>
                <p className="mt-1 text-sm text-slate-500">
                  {d.mandantNom}
                  {d.objet ? ` · ${d.objet}` : ''}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
